module.exports = __webpack_public_path__ + "static/media/River-Park-Court-Bylaws.74eb4a62.pdf";